<template>
  <div class="app-navbar-actions">
    <!-- Solde du compte (masqué pour Collaborateurs) -->
    <div v-if="userStore.role !== 'Collaborateur'" class="account-balance">
      <span class="balance-label">Solde:</span>
      <span class="balance-amount">{{ formattedBalance }}</span>
    </div>

    <!-- Séparateur -->
    <div class="separator">|</div>

    <!-- Heure locale Côte d'Ivoire -->
    <div class="local-time">
      {{ currentTime }}
    </div>

    <!-- Winner Trophy Indicator -->
    <WinnerIndicator />

    <NotificationDropdown class="app-navbar-actions__item" />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'
import WinnerIndicator from './WinnerIndicator.vue'
import { useUserStore } from '../../../stores/user-store'

const userStore = useUserStore()

defineProps({
  isMobile: { type: Boolean, default: false },
})

const currentTime = ref('')
let timeInterval: number | null = null

// Formater le solde
const formattedBalance = computed(() => {
  const balance = userStore.accountBalance || 0
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XOF', // Franc CFA
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(balance)
})

// Mettre à jour l'heure locale (Côte d'Ivoire = UTC+0)
const updateTime = () => {
  const now = new Date()
  currentTime.value = now.toLocaleTimeString('fr-FR', {
    timeZone: 'Africa/Abidjan', // Côte d'Ivoire
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

onMounted(() => {
  updateTime()
  timeInterval = window.setInterval(updateTime, 1000) // Mise à jour chaque seconde
})

onUnmounted(() => {
  if (timeInterval) {
    clearInterval(timeInterval)
  }
})
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;

  .account-balance {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: var(--va-text-primary);

    .balance-label {
      font-weight: 500;
    }

    .balance-amount {
      font-weight: 700;
      color: var(--va-primary);
    }
  }

  .separator {
    color: var(--va-text-secondary);
    font-size: 1.125rem;
    font-weight: 300;
  }

  .local-time {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--va-text-primary);
    font-variant-numeric: tabular-nums;
  }

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
